import { reportService } from '../../helpers/report.service';

export const actions = {
    searchLog({ dispatch, commit }, payload) {
        return new Promise((resolve, reject) => {
            reportService.searchLog(payload).then((response) => {
                resolve(response);
            }, (error) => {
                reject(_handleError(error));
            });
        });
    },
    lastLogin({ dispatch, commit }, payload) {
        return new Promise((resolve, reject) => {
            reportService.lastLogin(payload).then((response) => {
                resolve(response);
            }, (error) => {
                reject(_handleError(error));
            });
        });
    },
}

export const mutations = {

};

function _handleError(error) {
    var errorMessage = error.response ? error.response.statusText : error;
    return errorMessage;
};